<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="fabPieceId">Piece</label>
                    <wj-combo-box
                        id="fabPieceId"
                        name="fabPieceId"
                        [(ngModel)]="target.fabPieceId"
                        [itemsSource]="pieceOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="fabHoldReasonId">Reason</label>
                    <wj-combo-box
                        id="fabHoldReasonId"
                        name="fabHoldReasonId"
                        [(ngModel)]="target.fabHoldReasonId"
                        [itemsSource]="reasonOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="fabProcessStepId">Blocked Step</label>
                    <wj-combo-box
                        id="fabProcessStepId"
                        name="fabProcessStepId"
                        [(ngModel)]="target.fabProcessStepId"
                        [itemsSource]="stepOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="ownerUserId">Owner</label>
                    <wj-combo-box
                        id="ownerUserId"
                        name="ownerUserId"
                        [(ngModel)]="target.ownerUserId"
                        [itemsSource]="userList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="startedOn">Started On</label>
                    <wj-input-date id="startedOn" name="startedOn" [(ngModel)]="target.startedOn" [isRequired]="true"></wj-input-date>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="expectedReleaseDate">Expected Release</label>
                    <wj-input-date
                        id="expectedReleaseDate"
                        name="expectedReleaseDate"
                        [(ngModel)]="target.expectedReleaseDate"
                        [isRequired]="false"
                    ></wj-input-date>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="description">Description</label>
                    <textarea
                        id="description"
                        name="description"
                        class="form-control"
                        rows="3"
                        [(ngModel)]="target.description"
                    ></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
